import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  sortBy: '',
  viewType: '',
};

const gridListSortSelection = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.CLIENTS_SET_SORTBY_AND_VIEWTYPE:
      return {
        ...state,
        sortBy: payload.sortBy,
        viewType: payload.viewType,
      };
    default:
      return state;
  }
};

export default gridListSortSelection;
